<template>
  <div style="display: inline">
    <el-button 
      v-if="editDocument"
      type="primary" size="small" 
      @click="getListLog()" icon="el-icon-refresh-left" :loading="loadingLogs">
        Historial
    </el-button>
    <el-dialog title="Historial del documento" :visible.sync="dialogListLog" @closed="reset">
      <el-table :data="listLog">
        <el-empty slot="empty" description="No hay datos"></el-empty>
        <el-table-column type="index" width="40"></el-table-column>
        <el-table-column property="action" label="Acción"></el-table-column>
        <el-table-column property="date" label="Fecha" width="180"></el-table-column>
        <el-table-column property="user" label="Usuario"></el-table-column>
        <el-table-column property="observation" label="Observación"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getListLogByRegister } from '@/api/administration'
export default {
    data() {
      return {
        listLog: [],
        dialogListLog: false,
        loadingLogs: false,
      };
    },
    computed: {
    ...mapGetters(['editDocument', 'document']),
  },
  methods: {
    getListLog(){
      getListLogByRegister(this.document.id).then(({data}) => {
        data.forEach((element) => {
          this.listLog.push({
            action: element.accion,
            date: element.fecha,
            observation: element.observacion,
            user: element.user['name'],
          })
        })
        this.dialogListLog = true
      }).catch((e) => {
        console.log(e);
        this.$message({
          type: "error",
          message: "Error al consultar historial",
        });
      });
    },
    reset(){
      this.listLog = []
      this.registerId = null
    }
  },
};
</script>